import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["description"]

  connect() {
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.focus()
    }
  }

  submitOnKeydown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  reset() {
    this.element.reset()
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.focus()
    }
  }
}
